export default "__VITE_ASSET__dybxQKKr__"